export function filterConversations(list, query) {
  const q = (query || '').trim().toLowerCase()
  if (!q) return list
  return list.filter(c => (c.title || '').toLowerCase().includes(q))
}

export function debounce(fn, ms) {
  let timer = null
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), ms)
  }
}

export function historyEmptyState({ total, query, filtered }) {
  const hasQuery = !!(query || '').trim()
  if (total === 0 && !hasQuery) return 'first-run'
  if (hasQuery && filtered === 0) return 'no-results'
  return null
}

export function commitRenameTitle(draft, currentTitle) {
  const title = (draft || '').trim()
  if (title && title !== currentTitle) return title
  return null
}
